module.exports = __webpack_public_path__ + "static/img/08.e534c932.png";